import { AlertTriangle, Clock, TrendingUp, TrendingDown, Wrench, CheckCircle2 } from "lucide-react";
import { highlightNumbers } from "@/lib/highlightNumbers";

const ICONS = {
  alert: { Icon: AlertTriangle, color: "#f59e0b", bg: "#fef3c7" },
  clock: { Icon: Clock, color: "#3b82f6", bg: "#dbeafe" },
  "trend-up": { Icon: TrendingUp, color: "#22c55e", bg: "#dcfce7" },
  "trend-down": { Icon: TrendingDown, color: "#ef4444", bg: "#fee2e2" },
  wrench: { Icon: Wrench, color: "#3b82f6", bg: "#dbeafe" },
  check: { Icon: CheckCircle2, color: "#22c55e", bg: "#dcfce7" },
};

export default function QuickInsights({ insights = [] }) {
  return (
    <div className="space-y-3">
      {insights.length === 0 && (
        <div className="text-xs text-slate-400 text-center py-4">Not enough data for insights.</div>
      )}
      {insights.map((it) => {
        const cfg = ICONS[it.icon] || ICONS.alert;
        const { Icon } = cfg;
        const key = it.id ?? `${it.icon}-${it.text}`;
        return (
          <div key={key} className="flex gap-3">
            <div className="w-9 h-9 rounded-lg flex-shrink-0 flex items-center justify-center" style={{ background: cfg.bg, color: cfg.color }}>
              <Icon className="w-4.5 h-4.5" />
            </div>
            <div className="text-xs text-slate-700 leading-relaxed pt-1.5">
              {highlightNumbers(it.text, "text-[#1e40af] font-semibold")}
            </div>
          </div>
        );
      })}
    </div>
  );
}
